import { LEAFLINK_ACCESS_ID, LEAFLINK_PLUS_ID, URLS } from '@/constants';
import {
  DraftOrdersPostRequest,
  DraftOrdersPostResponse,
  FeatureEnrollmentPostRequest,
  ModifyPlanRequest,
  PlanSubscriptionsResponse,
  ProductsGetResponse,
} from '@/models/featureEnrollment';
import session from '@/services/session';

/**
 * POST: Enroll a feature
 */
export async function enroll(args: FeatureEnrollmentPostRequest) {
  const response = await session.post(`${URLS.FEATURE_ENROLLMENT.BASE}/`, args);

  return response.data;
}

/**
 * POST: Draft orders
 */
export async function draftOrders(args: DraftOrdersPostRequest): Promise<DraftOrdersPostResponse> {
  const response = await session.post(`${URLS.FEATURE_ENROLLMENT.DRAFT_ORDERS}/`, args);

  return response.data;
}

/**
 * GET: Products
 */
export async function products() {
  const url = `${URLS.FEATURE_ENROLLMENT.PRODUCTS}/`;

  const params = {
    error_format: 'jsonapi',
    product_ids: [LEAFLINK_PLUS_ID, LEAFLINK_ACCESS_ID].join(','),
  };

  const response = await session.get<ProductsGetResponse[]>(url, { params });

  return response.data;
}

/**
 * POST: Modify Plan
 */
export async function modifyPlan(args: ModifyPlanRequest) {
  const response = await session.post(`${URLS.FEATURE_ENROLLMENT.MODIFY_PLAN}/`, args);

  return response.data;
}

/**
 * GET: Plan Subscriptions
 */
export async function planSubscriptions(): Promise<PlanSubscriptionsResponse> {
  const response = await session.get(`${URLS.FEATURE_ENROLLMENT.PLAN_SUBSCRIPTIONS}/`);

  return response.data;
}
